/* eslint-disable react/jsx-pascal-case */
import React, { ReactNode, useCallback, useState } from 'react'
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import Paper from '@material-ui/core/Paper'
import CssBaseline from '@material-ui/core/CssBaseline'
import O_Header from 'components/3_Organisms/O_Header'
import O_SideMenu from 'components/3_Organisms/O_SideMenu'
import O_ContentHeader from 'components/3_Organisms/O_ContentHeader'
import { labels } from 'types/ReferTypes'
import { useMediaQueryContext } from 'MediaQueryProvider'
import O_HeaderMobile from 'components/3_Organisms/O_HeaderMobile'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(1),
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      backgroundColor: '#F3FFD8',
    },
  }),
)

type Props = {
  labels: labels
  pageTitle: string
  expandMode?: boolean // 検索項目を拡縮できるか
  open?: boolean
  changeOpen?: (bool: boolean) => void
  children: ReactNode
}

const T_Main = ({ labels, pageTitle, expandMode = false, open = false, changeOpen = (_: boolean) => {}, children }: Props): JSX.Element => {
  const classes = useStyles()
  const { isMobileSite } = useMediaQueryContext()
  // サイドメニュー開閉処理
  const [openMenu, changeOpenMenu] = useState(!isMobileSite)
  const handleOpenMenu = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault()
      changeOpenMenu(!openMenu)
    },
    [openMenu],
  )

  return (
    <div className={classes.root}>
      <CssBaseline />
      {isMobileSite ? <O_HeaderMobile sysName={labels.sysName} handleOpenMenu={handleOpenMenu} /> : <O_Header sysName={labels.sysName} handleOpenMenu={handleOpenMenu} />}
      <O_SideMenu menus={labels.sideMenus} openMenu={openMenu} />
      <main className={classes.content}>
        <Toolbar variant="dense" />
        <O_ContentHeader title={pageTitle} expandMode={expandMode} open={open} changeOpen={changeOpen} />
        <Paper className={classes.paper}>{children}</Paper>
      </main>
    </div>
  )
}

export default React.memo(T_Main)
